import axiosInstance from '../../../config/axiosInstance';
import { PartValidation } from "../View/Validation/PartValidation";

const handleChange = (event, formData, setFormData) => {
  const { name, value } = event.target;
  setFormData({
    ...formData,
    [name]: value,
  });
};

const handleSubmit = async (event, formData, setFormData, setErrors, redirectCallback, redirectUserList) => {
  event.preventDefault();
  const formErrors = PartValidation(formData);
  setErrors(formErrors);
  if (Object.keys(formErrors).length === 0) {
    try {
      const CompanyID=localStorage.getItem("CompanyID");
      formData.formData.ClientID=CompanyID;
      const UserID=localStorage.getItem("UserID");
      formData.formData.UserID=UserID;
      const response = await axiosInstance.post(`/Part/CreatePart`, formData);
      localStorage.setItem('StockID', response.data.StockID);
      return response.data.message;
    } catch (error) {
      console.error('Error posting data:', error);
    }
  }
};

export { handleChange, handleSubmit };